module.exports = __webpack_public_path__ + "static/media/file-chart-pie.84223cb4.svg";